import jsPDF from "jspdf";
import "jspdf-autotable";

export function generatePdf(record, title, tableData, objectType) {
  /**
   * Load Document For printing
   */

  var doc = new jsPDF({ compress: true });

  var objectName = title;

  doc.setFont("Georgia, serif", "bold");
  doc.setFontSize(16);
  var pageWidth =
    doc.internal.pageSize.width || doc.internal.pageSize.getWidth();
  var totalPagesExp = "{total_pages_count_string}";

  /*
          Constnats
      */
  const textFontSize = 11;
  //const tableTextFontSize = 10;
  /*
      LOGO
    */
  var img = new Image();
  img.src = require("@/assets/blue-header.png");
  doc.addImage(img, "png", 10, 15, pageWidth - 20, 50);

  doc.text(objectName, pageWidth / 2, 10, "center");
  doc.line(5, 11, pageWidth - 5, 11); // Top Line
  doc.setFontSize(10);

  //   doc.text("Original", pageWidth - 20, 14);

  doc.setFontSize(10);

  /*
    -------------------------------------------------------------------------------
                  BEGINNING OF CUSTOMER DETAILS AND DOCUMENT DETAILS
     -----------------------------------------------------------------------------
    */

  /**
   * Customer Details
   */
  doc.addFont("Tahoma");
  doc.setFont("Tahoma", "bold");
  doc.setFontSize(11);

  if (objectType == 14) {
    doc.text("Invoice No: " + record.DocNum, 10, 85);
  }

  if (objectType == 30) {
    doc.text("Quote No: " + record.DocNum, 10, 85);
  }

  doc.text("Customer: " + record.ocrd.Name, 10, 80);
  doc.text("Date: " + record.DocDate, pageWidth - 40, 80);

  doc.setFontSize(textFontSize);

  function headRowsItemDetails() {
    return [
      {
        count: "",
        description: "ITEM",
        Quantity: "QUANTITY",
        Price: "UNIT PRICE",
        total_amount: "AMOUNT",
      },
    ];
  }

  /*
    -------------------------------------------------------------------------------
                  BEGINNING OF ITEM DETAILS
     -----------------------------------------------------------------------------
    */

  const itemDetails = [];
  for (const note of tableData) {
    const i = tableData.indexOf(note);
    const itemDetail = {
      count: i + 1,
      description: note.product.Name,
      Quantity: note.Quantity.toLocaleString(),
      Price: note.Price.toLocaleString(),
      total_amount: note.LineTotal.toLocaleString(),
    };

    itemDetails.push(itemDetail);
  }

  const totalAmount = {
    Price: "TOTAL",
    total_amount: record.DocTotal.toLocaleString(),
  };

  itemDetails.push(totalAmount);

  doc.autoTable({
    head: headRowsItemDetails(),
    body: itemDetails,
    theme: "grid",
    headStyles: { fillColor: "#808080" },
    bodyStyles: {
      textColor: "#000000",
      fontSize: 12,
    },
    tableWidth: pageWidth - 20,
    columnStyles: {
      total_amount: {
        halign: "left",
        fontStyle: "bold",
      },
      Price: {
        fontStyle: "bold",
      },
      styles: {
        font: "Tahoma",
        fontSize: 12,
      },
    },

    margin: { left: 10 },
    didDrawPage: function(data) {
      // Footer
      var str = "Page " + doc.internal.getNumberOfPages();
      // Total page number plugin only available in jspdf v1.0+
      if (typeof doc.putTotalPages === "function") {
        str = str + " of " + totalPagesExp;
      }
      doc.setFontSize(10);
      doc.setTextColor(0, 0, 0);
      // jsPDF 1.4+ uses getWidth, <1.4 uses .width
      var pageSize = doc.internal.pageSize;
      var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();
      doc.text(str, data.settings.margin.right, pageHeight - 10);
    },

    startY: 90,
  });

  /*
    -------------------------------------------------------------------------------
                  BEGINNING FOOTER ITEM DETAILS
     -----------------------------------------------------------------------------
    */

  /**
   * Payment Term Details
   */

  // /**
  //  * Document Details Totals
  //  */
  // const documentTotalDetails = [];

  // const totalAmount = {
  //   count: "Total Amount:",
  //   name: "KES" + " " + record.DocTotal.toLocaleString(),
  // };

  // documentTotalDetails.push(totalAmount);

  // doc.autoTable({
  //   head: headRowsRefDetails(),
  //   body: documentTotalDetails,
  //   theme: "plain",
  //   tableWidth: 70,
  //   pageBreak: "auto",
  //   rowPageBreak: "avoid",
  //   columnStyles: {
  //     count: {
  //       halign: "left",
  //     },
  //     name: {
  //       fontStyle: "bold",
  //       halign: "right",
  //     },
  //   },
  //   startY: StartOfOtherTables,
  //   styles: {
  //     overflow: "hidden",

  //     fontSize: 9,
  //   },
  //   margin: { left: 146 },
  // });

  /**
   * Line After Doc Total
   *
   */
  // doc.setDrawColor(0, 0, 0);
  // doc.setFont("Tahoma", "bold");
  // doc.line(
  //   5,
  //   doc.autoTable.previous.finalY + 1,
  //   pageWidth - 5,
  //   doc.autoTable.previous.finalY + 1
  // );

  /**
   * Document Remarks
   *
   */

  var pageSize = doc.internal.pageSize;
  var pageHeight = pageSize.height ? pageSize.height : pageSize.getHeight();

  var footerImg = new Image();
  footerImg.src = require("@/assets/blue-footer.png");
  doc.addImage(footerImg, "png", 0, pageHeight - 70, pageWidth, 70);

  let customerName = record.ocrd.Name;

  let printStr = "";
  if (objectType == 14) {
    printStr = customerName + "-" + record.DocDate + "-invoice.pdf";
  }

  if (objectType == 30) {
    printStr = customerName + "-" + record.DocDate + "-quote.pdf";
  }

  doc.save(printStr);
  //   doc.output("dataurlnewwindow");
}
